<mat-card class="bot-thumb">
  <mat-card-header>
    <mat-card-title>{{ bot.name }}</mat-card-title>
    <mat-card-subtitle>
      @for (label of bot.labels; track label) {
      <span>{{ label }}</span>
      }
    </mat-card-subtitle>
    <mat-card-actions>
      <mat-icon [matTooltip]="bot.device">
        {{ bot.device | deviceIcon }}
      </mat-icon>
    </mat-card-actions>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    <p class="description">{{ bot.description }}</p>
    <mat-divider></mat-divider>
    <div class="incident-summary">
      <span
        class="incident-pill"
        [class.has-incidents]="incidentCounts.threeDays > 0"
        [matBadge]="incidentCounts.threeDays"
        [matBadgeHidden]="incidentCounts.threeDays === 0"
        matBadgeColor="warn"
        matBadgePosition="above after"
        i18n-matTooltip="
          component bot dashboard user | tooltip incidents 3 jours
        "
        matTooltip="Incidents sur les 3 derniers jours: {{
          incidentCounts.threeDays
        }}"
        i18n="component bot dashboard user | badge 3 jours"
      >
        J-3
      </span>
      <span
        class="incident-pill"
        [class.has-incidents]="incidentCounts.sevenDays > 0"
        [matBadge]="incidentCounts.sevenDays"
        [matBadgeHidden]="incidentCounts.sevenDays === 0"
        matBadgeColor="warn"
        matBadgePosition="above after"
        i18n-matTooltip="
          component bot dashboard user | tooltip incidents 7 jours
        "
        matTooltip="Incidents sur les 7 derniers jours: {{
          incidentCounts.sevenDays
        }}"
        i18n="component bot dashboard user | badge 7 jours"
      >
        J-7
      </span>
      <span
        class="incident-pill"
        [class.has-incidents]="incidentCounts.oneMonth > 0"
        [matBadge]="incidentCounts.oneMonth"
        [matBadgeHidden]="incidentCounts.oneMonth === 0"
        matBadgeColor="warn"
        matBadgePosition="above after"
        i18n-matTooltip="
          component bot dashboard user | tooltip incidents 1 mois
        "
        matTooltip="Incidents sur le dernier mois: {{
          incidentCounts.oneMonth
        }}"
        i18n="component bot dashboard user | badge 1 mois"
      >
        J-30
      </span>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <div class="flex justify-center">
      <button
        type="button"
        mat-stroked-button
        color="primary"
        (click)="navigateToBot()"
      >
        <mat-icon>visibility</mat-icon>
        <span i18n="component bot dashboard user | bouton">voir plus</span>
      </button>
    </div>
  </mat-card-footer>
</mat-card>
